import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

import { UsageDetailDataInputType } from '@/graphql/contracts/_generated_/contracts';

import RestoreUsageDetailsMutation from '@/graphql/contracts/restoreUsageDetails.mutation.gql';

import GetVarBillingUsageHeaderQuery from '@/graphql/contracts/getVarBillingUsageHeader.query.gql';
import { RestoreUsageDetails, RestoreUsageDetailsVariables } from
  '@/graphql/contracts/_generated_/restoreUsageDetails.mutation';

export default function useRestoreUsageDetails() {
  const { fileId }: { fileId: string } = useParams();

  const [restoreDetails, { loading }] = useMutation<RestoreUsageDetails, RestoreUsageDetailsVariables>(
    RestoreUsageDetailsMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => {
        notificationService.open({
          title: 'Usage Details Restored',
          text: 'Usage Details restored successfully',
          type: 'success'
        });
      }
    }
  );

  const restoreUsageDetails = async (usageHeaderId: string, usageDetails: UsageDetailDataInputType[]) => {
    const res = await restoreDetails({
      variables: {
        input: { usageHeaderId, usageDetails }
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetVarBillingUsageHeaderQuery,
          variables: {
            id: fileId
          },
        },
      ],
    });

    return res?.data?.restoreUsageDetails ?? null;
  };

  return {
    restoreUsageDetails,
    isLoadingRestoreUsageDetails: loading
  } as const;
}
